var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDisplay = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 49 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 24.5,
  cy: 24.5,
  r: 24.5,
  fill: "#8486EC"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.479,
  cy: 27.505,
  r: 2.004,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.628 31.948c6.555 3.904 13.968 1.353 14.893-5.598M34.517 21.495a2.004 2.004 0 1 0-4.008 0M27.507 16.486l-.002-.003M38.522 16.486l.002-.003M31.219 14.19v.584M35.228 14.19v.584",
  stroke: "#fff",
  strokeWidth: 1.42,
  strokeLinecap: "round"
})));
export default SvgDisplay;